<template>
  <div>
    <nav>
      <div class="c-dealer-left">
        <a href="https://audipoznan.pl/">
          <p class="c-dealer-red">Audi</p>
          <p class="">Porsche Franowo</p>
        </a>
      </div>
      <a href="https://audipoznan.pl/"><img src='@/assets/images/elem/logo.png' /></a>
    </nav>
    <div class="c-model-baner">
      <img class='baner' src='@/assets/images/baner_lp.jpg' alt="audi "/>
      <div class="pulse-div" v-scroll-to="'#offers_div'">
        <span class="pulse"><img src='@/assets/images/elem/mouse.png' alt='Audi Poznań' /></span>
        <p class="check" style="color:#fff;">Sprawdź</p>
      </div>
      <div class="c-baner-text">
        <h1 class="c-baner-text2">
          Doświadczenie, które procentuje.
        </h1>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'headercomponent',
  methods: {
    scrolltoelement: function scrolltoelement() {
      console.log("test");
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: document.getElementsByClassName('c-model-baner-text').offsetTop
      });
    },
  }

};
</script>
